module.exports = __webpack_public_path__ + "img/teamImg9.20fda3b2.jpg";